const pageNameKey = "otaAbortInstall";

export const otaAbortInstallEn = {
  [pageNameKey]: {
    installAbortedText: "Installation aborted.",
    failedToAbort: "Failed to abort installation",
    errorWhileInstallation: "Error while aborting installation",
  },
};

export const otaAbortInstallPtBr = {
  [pageNameKey]: {
    installAbortedText: "Instalação abortada.",
    failedToAbort: "Falha ao cancelar a instalação",
    errorWhileInstallation: "Erro ao cancelar a instalação",
  },
};

export const otaAbortInstallDe = {
  [pageNameKey]: {
    installAbortedText: "Installation abgebrochen.",
    failedToAbort: "Abbruch der Installation fehlgeschlagen",
    errorWhileInstallation: "Fehler beim Abbrechen der Installation",
  },
};

export const otaAbortInstallZhHans = {
  [pageNameKey]: {
    installAbortedText: "安装已中止。",
    failedToAbort: "中止安装失败",
    errorWhileInstallation: "中止安装时出错",
  },
};

export const otaAbortInstallIt = {
  [pageNameKey]: {
    installAbortedText: "Installazione interrotta.",
    failedToAbort: "Impossibile interrompere l'installazione",
    errorWhileInstallation: "Errore durante l'interruzione dell'installazione",
  },
};

export const otaAbortInstallEs = {
  [pageNameKey]: {
    installAbortedText: "Instalación cancelada.",
    failedToAbort: "No se pudo abortar la instalación",
    errorWhileInstallation: "Error al cancelar la instalación",
  },
};

export const otaAbortInstallNl = {
  [pageNameKey]: {
    errorWhileInstallation: "Fout bij het annuleren van de installatie",
    failedToAbort: "Annuleren van de installatie mislukt",
    installAbortedText: "Installatie geannuleerd.",
  },
};

export const otaAbortInstallTr = {
  [pageNameKey]: {
    errorWhileInstallation: "Kurulumu iptal ederken hata oluştu",
    failedToAbort: "Kurulum iptal edilemedi",
    installAbortedText: "Kurulum iptal edildi.",
  },
};
